import { __awaiter } from "tslib";
import { FeaturesType } from "@rcsb/rcsb-api-tools/lib/RcsbGraphQL/Types/Borrego/GqlTypes";
import { Operator } from "../../../../RcsbUtils/Helpers/Operator";
import { range } from "lodash";
import { PlainAlignmentTrackFactory } from "./PlainAlignmentTrackFactory";
import { TrackUtils } from "./Helper/TrackUtils";
import { rcsbRequestCtxManager } from "../../../../RcsbRequest/RcsbRequestContextManager";
import { Assertions } from "../../../../RcsbUtils/Helpers/Assertions";
var assertDefined = Assertions.assertDefined;
import { TagDelimiter } from "@rcsb/rcsb-api-tools/lib/RcsbUtils/TagDelimiter";
export class PositionalScoreAlignmentTrackFactory {
    constructor(entityInstanceTranslator) {
        this.positionalScores = new Map();
        this.instanceEntityMap = new Map();
        this.alignmentTrackFactory = new PlainAlignmentTrackFactory(entityInstanceTranslator);
    }
    getTrack(alignmentRequestContext, targetAlignment, alignedRegionToTrackElementList) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.alignmentTrackFactory.getTrack(alignmentRequestContext, targetAlignment, this.alignedRegionToTrackElementList.bind(this), {
                colors: ["#ff7d45", "#ffdb13", "#65cbf3", "#0053d6"],
                thresholds: [50, 70, 90]
            });
        });
    }
    prepareFeatures(positionalScores) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.collectFeatureEntryProperties(positionalScores);
            this.prepareFeaturesAlignmentMap(positionalScores);
        });
    }
    collectFeatureEntryProperties(unObservedRegions) {
        return __awaiter(this, void 0, void 0, function* () {
            const entryIds = Operator.uniqueValues(unObservedRegions.map(uor => {
                assertDefined(uor.target_id);
                return uor.target_id.split(TagDelimiter.instance)[0];
            }));
            //TODO define a Translator class for multiple entry entry data
            const entryProperties = (yield Promise.all(Operator.arrayChunk(entryIds, 100).map(ids => rcsbRequestCtxManager.getEntryProperties(ids)))).flat();
            entryProperties.forEach(ep => {
                ep.entityToInstance.forEach((instanceList, entityId) => {
                    instanceList.forEach(instanceId => {
                        this.instanceEntityMap.set(instanceId, entityId);
                    });
                });
            });
        });
    }
    prepareFeaturesAlignmentMap(positionalScores) {
        const instancePositionalScores = new Map();
        positionalScores.forEach(ps => {
            var _a;
            if (!ps.target_id)
                return;
            const instanceId = ps.target_id;
            if (!instancePositionalScores.has(instanceId))
                instancePositionalScores.set(instanceId, new Map());
            (_a = ps.features) === null || _a === void 0 ? void 0 : _a.forEach(feature => {
                var _a;
                (_a = feature === null || feature === void 0 ? void 0 : feature.feature_positions) === null || _a === void 0 ? void 0 : _a.forEach(fp => {
                    var _a;
                    (_a = fp === null || fp === void 0 ? void 0 : fp.values) === null || _a === void 0 ? void 0 : _a.forEach((v, n) => {
                        var _a;
                        if (fp.beg_seq_id && v)
                            (_a = instancePositionalScores.get(instanceId)) === null || _a === void 0 ? void 0 : _a.set(fp.beg_seq_id + n, v);
                    });
                });
            });
        });
        const entityPositionalScore = new Map();
        instancePositionalScores.forEach((ips, instanceId) => {
            const entityId = this.instanceEntityMap.get(instanceId);
            if (!entityId)
                return;
            if (!entityPositionalScore.has(entityId))
                entityPositionalScore.set(entityId, new Map());
            const o = entityPositionalScore.get(entityId);
            assertDefined(o);
            ips.forEach((score, position) => {
                var _a;
                if (!o.has(position)) {
                    o.set(position, score);
                }
                else if (score < ((_a = o.get(position)) !== null && _a !== void 0 ? _a : Number.MIN_SAFE_INTEGER)) {
                    o.set(position, score);
                }
            });
        });
        this.positionalScores = entityPositionalScore;
    }
    alignedRegionToTrackElementList(region, alignmentContext) {
        var _a;
        if (!this.positionalScores.has(alignmentContext.targetId) || ((_a = this.positionalScores.get(alignmentContext.targetId)) === null || _a === void 0 ? void 0 : _a.size) == 0)
            return this.alignmentTrackFactory.alignedRegionToTrackElementList(region, alignmentContext);
        const outRegions = [];
        const entityPositionalScores = this.positionalScores.get(alignmentContext.targetId);
        if (entityPositionalScores && entityPositionalScores.size > 0) {
            range(region.query_begin, region.query_end + 1).forEach((p, n) => {
                if (!alignmentContext.to)
                    return;
                outRegions.push(this.alignmentTrackFactory.addAuthorResIds({
                    begin: p,
                    oriBegin: region.target_begin + n,
                    value: entityPositionalScores.get(p),
                    sourceId: alignmentContext.targetId,
                    source: TrackUtils.transformSourceFromTarget(alignmentContext.targetId, alignmentContext.to),
                    provenanceName: TrackUtils.getProvenanceConfigFormTarget(alignmentContext.targetId, alignmentContext.to).name,
                    provenanceColor: TrackUtils.getProvenanceConfigFormTarget(alignmentContext.targetId, alignmentContext.to).color,
                    type: FeaturesType.MaQaMetricLocalTypeOther,
                }, alignmentContext));
            });
        }
        return outRegions;
    }
}
//# sourceMappingURL=PositionalScoreAlignmentTrackFactory.js.map